import styled from 'styled-components';

export const ObservationText = styled.div`
  font-size: 11.5px;
`;
